const en = {
  nav: {
    features: 'Features',
    pricing: 'Pricing',
    signIn: 'Sign In',
    getStarted: 'Get Started',
    home: 'Home',
    dashboard: 'Dashboard',
    quotations: 'Quotations',
    invoices: 'Invoices',
    receipts: 'Receipts',
    bills: 'Bills',
    documents: 'All Documents',
    docGroup: 'Documents',
    newDoc: 'New',
    support: 'Support',
    supportCases: 'Support Cases',
    clients: 'Clients',
    items: 'Items',
    settings: 'Settings',
    subscription: 'Subscription',
    profile: 'Profile',
    admin: 'Admin',
    system: 'System',
    users: 'Users',
    userStats: 'User Statistics',
    finance: 'Finance',
    activity: 'Activity Log',
    backups: 'Backups',
    changelog: 'Version History',
    signOut: 'Sign Out',
    viewProfile: 'View profile',
    collapse: 'Collapse',
    light: 'Light',
    dark: 'Dark',
    full: 'Full',
    exit: 'Exit',
    recurring: 'Recurring',
  },
  hero: {
    eyebrow: 'Business Document Management',
    headline1: 'Quotations, invoices',
    headline2: 'and receipts.',
    headline3: 'Done right.',
    sub: 'Stop wrestling with Word templates and spreadsheets. Invio gives you branded PDFs, client tracking, multi-currency support and a 30-day free trial.',
    ctaPrimary: 'Start free 30-day trial →',
    ctaSecondary: 'See pricing',
    trust: '✓ No credit card required  ·  ✓ Cancel anytime  ·  ✓ Set up in 60 seconds',
  },
  stats: {
    docTypes: 'Document types',
    currencies: 'Currencies supported',
    languages: 'Languages',
    docsPerMo: 'Documents per month',
    dayTrial: 'Day free trial',
  },
  features: {
    eyebrow: 'Features',
    title: 'Everything you need to bill clients',
    sub: 'One tool for every business document — no add-ons, no upsells.',
    items: {
      quotations:    { title: 'Quotations',         desc: 'Send polished proposals and convert them to invoices in one click.' },
      invoices:      { title: 'Invoices',           desc: 'Bill clients with auto-numbered, branded PDFs ready in seconds.' },
      receipts:      { title: 'Receipts',           desc: 'Issue payment receipts that match your invoice exactly.' },
      bills:         { title: 'Bills',              desc: 'Track supplier bills alongside what you charge clients.' },
      purchase:      { title: 'Purchase & Delivery',desc: 'POs and delivery orders for goods you order or ship.' },
      credit:        { title: 'Credit Notes',       desc: 'Issue refunds and adjustments with a full paper trail.' },
      clients:       { title: 'Client Address Book',desc: 'Reusable client records that auto-fill every document.' },
      multiCurrency: { title: 'Multi-currency',     desc: '{count} currencies including USD, EUR, MYR, CNY and the full Arab League.' },
      export:        { title: 'PDF & Word Export',  desc: 'Print-ready PDFs and editable .docx for every document type.' },
      aiExtract:     { title: 'AI Document Import', desc: 'Upload a supplier price list, invoice or catalogue — our AI OCR extracts every line item into your database in seconds.' },
    },
  },
  ai: {
    eyebrow: 'New · AI OCR',
    title: 'Stop typing items by hand',
    sub: 'Drop a supplier PDF, an Excel sheet, a CSV or even a photo of a price list — Invio reads it with AI-powered OCR and turns every row into an editable item ready to add to your catalogue.',
    bullet1: 'PDFs, images, Excel and CSV — all in one upload',
    bullet2: 'Auto-fills SKU, supplier, cost, brand, tax rate and more',
    bullet3: 'Review, edit and pick which items to save before anything hits your database',
    cta: 'Try it free for 30 days',
  },
  pricing: {
    eyebrow: 'Pricing',
    title: 'Simple, transparent pricing',
    sub: 'Start with a 30-day free trial. No credit card required.',
    monthly: 'Monthly',
    yearly: 'Yearly',
    perMonth: '/month',
    perYear: '/year',
    save: 'Save {p}%',
    cta: 'Start free trial',
    custom: 'Custom',
    customPrice: "Let's talk",
    customSub: 'Tailored to your team',
    contactUs: 'Talk to Us',
    plan: {
      monthly: { f1: 'Unlimited documents', f2: 'AI item extraction', f3: 'PDF & Word export', f4: 'Cancel anytime' },
      yearly:  { f1: '{amount}/mo equivalent', f2: 'Unlimited documents', f3: 'AI item extraction', f4: 'PDF & Word export' },
      custom:  { f1: 'Custom features & integrations', f2: 'Volume discounts', f3: 'Priority support', f4: 'Multi-user team accounts' },
    },
  },
  finalCta: {
    title: 'Ready to send your first invoice?',
    sub: 'Set up your company profile in 60 seconds. Issue your first quotation today.',
    button: 'Get started free →',
  },
  footer: {
    tagline: 'Professional business document management for small teams.',
    product: 'Product',
    account: 'Account',
    contact: 'Contact',
    createAccount: 'Create account',
    legal: 'Legal',
    terms: 'Terms of Service',
    privacy: 'Privacy Policy',
    refund: 'Refund Policy',
    copyright: '© {year} Invio · invio.my',
  },
  banner: {
    verifyEmail: '⚠ Verify your email.',
    weSentLink: 'We sent a confirmation link to',
    resend: 'Resend email',
    sending: 'Sending…',
    deactivated: 'Your account has been deactivated. Contact the administrator.',
    updateAvailable: 'Update available',
    newVersionReady: 'A new version (v{v}) is ready. Refresh to load the latest.',
    refreshNow: 'Refresh now',
    trialEnded: 'Your trial has ended',
    graceDaysLeft: 'you have {d} day(s) of grace access left. Subscribe to keep using Invio.',
    subscribeNow: 'Subscribe now',
    paymentFailed: 'Payment failed',
    paymentFailedMsg: "we couldn't charge your card. Update your payment method within {d} day(s) to keep access.",
    updatePayment: 'Update payment method',
    trialExtended: 'Your trial has been extended',
    trialExtendedBy: 'we added {d} extra day(s). Your trial now ends on {date}.',
    dismiss: 'Dismiss',
  },
  emailPrefs: {
    title: 'Email notifications',
    subtitle: 'Choose which optional emails we send you.',
    securityAlerts: 'New sign-in alerts',
    securityAlertsDesc: 'Email me when my account is signed in to from a new device or browser.',
    announcements: 'Product updates',
    announcementsDesc: 'Occasional news about new Invio features and improvements.',
    transactionalNote: 'Essential emails — verification, password resets, security codes, billing and trial notices — are always sent.',
  },
  sessions: {
    title: 'Active sessions',
    subtitle: 'Devices signed in to your account — sign out any you don\'t recognise.',
    activeDevices: 'Signed-in devices',
    none: 'No other active sessions.',
    thisDevice: 'This device',
    lastActive: 'Last active {when}',
    revoke: 'Sign out',
    signOutOthers: 'Sign out of all other devices',
    now: 'just now',
    minAgo: '{n} min ago',
    hrAgo: '{n} h ago',
  },
  twofa: {
    title: 'Two-step verification',
    enterAppCode: 'Enter the 6-digit code from your authenticator app.',
    enterEmailCode: 'We emailed you a 6-digit code. Enter it below.',
    trustDevice: "Don't ask again on this device for 30 days",
    verify: 'Verify',
    resend: 'Resend code',
    codeSent: 'Code sent ✓',
    section: 'Two-factor authentication (2FA)',
    sectionSub: 'A second step at sign-in keeps your account safe even if your password leaks.',
    statusOff: 'Off',
    statusApp: 'On — authenticator app',
    statusEmail: 'On — email codes',
    useApp: 'Use an authenticator app',
    useEmail: 'Use email codes',
    scanQr: 'Scan this QR code with Google Authenticator, Microsoft Authenticator, Authy or any TOTP app.',
    manualKey: 'Or enter this key manually:',
    thenEnter: 'Then enter the 6-digit code the app shows:',
    activate: 'Activate',
    emailSent: 'We sent a 6-digit code to {email}. Enter it to switch on email codes.',
    enabled: 'Two-factor authentication is on',
    disabled: 'Two-factor authentication is off',
    activeApp: 'Signing in requires a code from your authenticator app.',
    activeEmail: 'Signing in requires a code sent to your email.',
    turnOff: 'Turn off',
    confirmPassword: 'Enter your password to turn off two-factor authentication:',
  },
  auth: {
    signInTab: 'Sign In',
    registerTab: 'Register',
    welcomeBack: 'Welcome back',
    createAccountTitle: 'Create your account',
    signInSub: 'Sign in to manage your business documents.',
    registerSub: 'Get started with Invio today.',
    fullName: 'Full Name',
    fullNamePlaceholder: 'Your name',
    email: 'Email Address',
    emailPlaceholder: 'you@example.com',
    password: 'Password',
    passwordPlaceholder: '••••••••',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    pleaseWait: 'Please wait…',
    signInBtn: 'Sign In',
    createAccountBtn: 'Create Account',
    invalidCredentials: 'Invalid email or password.',
    weakPassword: 'Password does not meet the security requirements.',
    backToSignIn: 'Back to sign in',
    resetTitle: 'Reset your password',
    resetIntro: "Enter the email address linked to your account and we'll send you a reset link.",
    sendResetLink: 'Send Reset Link',
    checkInbox: 'Check your inbox',
    ifRegistered: 'If {email} is registered, a password reset link has been sent.',
    backToSignInBtn: 'Back to Sign In',
    resetSendFailed: 'Could not send the reset link. Please try again.',
    resetSpamHint: 'The link expires in 1 hour. If the email doesn\'t arrive within a few minutes, check your spam folder.',
    agree: 'By creating an account, you agree to our {terms} and {privacy}.',
    tagline: 'Professional business document management — quotations, invoices, receipts and more.',
    feature1: 'Quotations & Invoices',
    feature2: 'Client Management',
    feature3: 'PDF & Word Export',
  },
  docType: {
    quotation: 'Quotation', invoice: 'Invoice', bill: 'Bill', receipt: 'Receipt',
    purchase_order: 'Purchase Order', delivery_order: 'Delivery Order',
    credit_note: 'Credit Note', statement: 'Statement',
  },
  status: {
    draft: 'Draft', sent: 'Sent', accepted: 'Accepted', rejected: 'Rejected',
    paid: 'Paid', overdue: 'Overdue', cancelled: 'Cancelled',
    partial: 'Partially paid',
  },
  doc: {
    description: 'Description', qty: 'Qty', unitPrice: 'Unit Price', amount: 'Amount',
    subtotal: 'Subtotal', discount: 'Discount', tax: 'Tax', total: 'TOTAL',
  },
  docs: {
    allDocuments: 'All Documents',
    titlePlural: {
      quotation: 'Quotations', invoice: 'Invoices', bill: 'Bills', receipt: 'Receipts',
      purchase_order: 'Purchase Orders', delivery_order: 'Delivery Orders',
      credit_note: 'Credit Notes', statement: 'Statements',
    },
    count: '{n} document(s)',
    document: 'Document',
    newType: 'New {type}',
    searchPlaceholder: 'Search by number or client…',
    allTypes: 'All Types',
    allStatus: 'All Status',
    noneFound: 'No {title} found',
    createFirst: 'Create your first {type}',
    thType: 'Type', thNumber: 'Number', thClient: 'Client', thDate: 'Date',
    thAmount: 'Amount', thStatus: 'Status', thActions: 'Actions',
    view: 'View', edit: 'Edit', copy: 'Copy', del: 'Del',
    confirmDelete: 'Delete this document?',
    duplicateFailed: 'Could not duplicate document',
  },
  editor: {
    editTitle: 'Edit {type}',
    newTitle: 'New {type}',
    saveChanges: 'Save Changes',
    createDocument: 'Create Document',
    documentDetails: 'Document Details',
    documentType: 'Document Type',
    status: 'Status',
    issueDate: 'Issue Date',
    validUntil: 'Valid Until',
    dueDate: 'Due Date',
    referenceNumber: 'Reference Number',
    auto: 'Auto',
    manual: 'Manual',
    autoGenerated: 'Will be auto-generated (e.g. QT-2026-0001)',
    supplierBillTo: 'Supplier & Bill To',
    client: 'Client',
    supplierName: 'Supplier Name',
    supplierNamePh: 'Supplier company name',
    supplierAddress: 'Supplier Address',
    supplierAddressPh: 'Supplier address',
    billToClient: 'Bill To (Client)',
    selectClientPh: 'Select client…',
    selectClient: 'Select Client',
    noClient: '— No client —',
    addClient: '+ Add Client',
    items: 'Items',
    titleOptional: 'Title (optional)',
    titlePh: 'e.g. Project ABC – Phase 1',
    hidePrices: 'Hide prices on this delivery order',
    hidePricesHint: 'Removes the Unit Price and Amount columns plus all totals from the PDF and Word file. Prices you have entered are kept, so unticking this brings them back.',
    itemDescriptionPh: 'Item description',
    saveAsItem: 'Save as reusable item',
    removeRow: 'Remove row',
    addItem: '+ Add Item',
    fromSaved: 'From saved',
    notesTerms: 'Notes & Terms',
    notesLabel: 'Notes (visible to client)',
    notesPh: 'Thank you for your business…',
    termsLabel: 'Terms & Conditions',
    termsPh: 'Payment terms, delivery conditions…',
    includeSignature: 'Include signature block in PDF',
    currencyPricing: 'Currency & Pricing',
    currency: 'Currency',
    taxRatePct: 'Tax Rate (%)',
    discountType: 'Discount Type',
    fixed: 'Fixed',
    percent: 'Percent',
    discountValue: 'Discount Value',
    summary: 'Summary',
    pricesHiddenEditorNote: 'Prices are hidden on this delivery order — the figures below are stored but will not appear in the PDF or Word file.',
    generating: 'Generating…',
    previewPdf: 'Preview / Print PDF',
    downloadWord: 'Download Word (.docx)',
    pickSavedItem: 'Pick a saved item',
    noSavedItems: 'No saved items yet.',
    manageItems: 'Manage Items',
    searchItemsPh: 'Search items…',
    itemNeedsDescription: 'Item {n} needs a description',
    docUpdated: 'Document updated!',
    docCreated: 'Document created!',
    errorSaving: 'Error saving',
    pdfFailed: 'Could not generate PDF',
    wordFailed: 'Could not generate Word file',
    addDescriptionFirst: 'Add a description first',
    savedToLibrary: 'Saved to Items library',
    couldNotSaveItem: 'Could not save item',
  },
  docView: {
    back: 'Back',
    issuedOn: 'Issued {date}',
    statusUpdated: 'Status updated to {s}',
    converted: 'Converted to {t}!',
    duplicated: 'Document duplicated!',
    deleteConfirm: 'Delete this document permanently?',
    notFound: 'Document not found.',
    from: 'From',
    supplier: 'Supplier',
    billedTo: 'Billed To',
    updateStatus: 'Update Status',
    dates: 'Dates',
    linkedDocument: 'Linked Document',
    paymentDetails: 'Payment Details',
    bank: 'Bank',
    account: 'Account',
    name: 'Name',
    notes: 'Notes',
    terms: 'Terms & Conditions',
    pricesHiddenView: 'Prices are hidden on this delivery order.',
    convertDocument: 'Convert Document',
    convertIntro: 'Convert {n} to a new document type. The original will be marked as accepted.',
    convertTo: 'Convert To',
    convert: 'Convert',
    duplicate: 'Duplicate',
  },
  clients: {
    title: 'Clients',
    count: '{n} client(s)',
    addClient: 'Add Client',
    empty: 'No clients yet. Add your first client to get started.',
    editClient: 'Edit Client',
    fullName: 'Full Name *',
    company: 'Company',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    notes: 'Notes',
    notesPh: 'Any notes about this client…',
    updated: 'Client updated!',
    added: 'Client added!',
    deleted: 'Client deleted',
    confirmDelete: 'Delete this client?',
  },
  items: {
    title: 'Items',
    count: '{n} saved item(s)',
    importBtn: 'Import from Document',
    addItem: 'Add Item',
    searchPh: 'Search by description, SKU, supplier, brand, category…',
    empty: 'No saved items yet. Add reusable products or services to speed up document creation.',
    noMatch: 'No items match "{q}".',
    unitPrice: 'Unit price',
    unit: 'Unit',
    inStock: 'In stock',
    supplier: 'Supplier',
    editItem: 'Edit Item',
    description: 'Description *',
    descriptionPh: 'Website design package',
    unitPriceLabel: 'Unit Price ({s})',
    costPriceLabel: 'Cost Price ({s})',
    taxRate: 'Tax Rate (%)',
    unitLabel: 'Unit',
    unitPh: 'hour, pcs, day…',
    category: 'Category',
    categoryPh: 'Service, Product…',
    stockQty: 'Stock Quantity',
    sku: 'SKU',
    skuPh: 'Product code',
    barcode: 'Barcode',
    barcodePh: 'UPC / EAN',
    brand: 'Brand',
    notes: 'Notes',
    notesPh: 'Any internal notes about this item…',
    updated: 'Item updated!',
    added: 'Item added!',
    deleted: 'Item deleted',
    confirmDelete: 'Delete this item?',
    errorSaving: 'Error saving',
    aiPaidOnly: 'AI import is available on paid plans. Upgrade on the Subscription page to use it.',
    importTitle: 'Import Items from Document',
    importIntro: 'Upload a PDF, image, Excel (.xlsx/.xls) or CSV file. Our AI OCR will extract the items, then you can review and edit before saving.',
    takePhoto: 'Take photo',
    noneDetected: 'No items detected in this document.',
    extractionFailed: 'Extraction failed.',
    cameraFailed: 'Camera failed.',
    foundSelected: '{n} item(s) found · {c} selected',
    selectAll: 'Select all',
    clear: 'Clear',
    thDescription: 'Description', thUnitPrice: 'Unit Price', thCost: 'Cost', thUnit: 'Unit',
    thSku: 'SKU', thCategory: 'Category', thBrand: 'Brand', thSupplier: 'Supplier',
    thTax: 'Tax %', thQty: 'Qty',
    working: 'Working…',
    saveCount: 'Save {n} item(s)',
    selectAtLeastOne: 'Select at least one item',
    imported: 'Imported {n} item(s)',
    importFailed: 'Import failed',
  },
  profile: {
    title: 'My Profile',
    subtitle: 'Manage your account details and security',
    accountInfo: 'Account Information',
    accountInfoSub: 'Update your name and email address',
    emailChangeHint: 'For your security, changing your email needs your password. We\'ll send a confirmation link to the new address — your current email keeps working until you confirm.',
    emailNeedsPassword: 'Enter your current password to change your email.',
    sendConfirmation: 'Send confirmation',
    emailConfirmSent: 'Confirmation sent to {email}. Click the link there to finish the change — your current email still works until then.',
    emailPending: 'Change to {email} is pending — check that inbox for the confirmation link.',
    cancelEmailChange: 'Cancel email change',
    emailChangeCancelled: 'Email change cancelled',
    uploadPhoto: 'Upload photo',
    changePhoto: 'Change photo',
    removePhoto: 'Remove',
    photoUpdated: 'Profile photo updated',
    photoRemoved: 'Profile photo removed',
    photoTooLarge: 'Image is too large. Please use one under 1 MB.',
    fullName: 'Full Name',
    fullNamePh: 'Your name',
    email: 'Email Address',
    updated: 'Profile updated!',
    updateFailed: 'Failed to update profile',
    changePassword: 'Change Password',
    changePasswordSub: 'Use a strong password with at least 6 characters',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    noMatch: 'Passwords do not match',
    weakPassword: 'New password does not meet the security requirements.',
    changed: 'Password changed successfully!',
    changeFailed: 'Failed to change password',
    updating: 'Updating…',
    updatePassword: 'Update Password',
    session: 'Session',
    sessionSub: 'Manage your active login session',
    signedInAs: 'Signed in as',
    thisDevice: 'This device',
    memberSince: 'Member since',
    protected: 'On',
    signOutOf: 'Sign out of Invio',
    redirected: 'You will be redirected to the login page.',
    accountType: 'Account Type',
    standard: 'Standard',
    plan: 'Plan',
    comingSoon: 'Coming Soon',
    photoUpload: 'Profile photo upload',
    twoFactor: 'Two-factor authentication',
    emailNotifications: 'Email notifications',
    sessionMgmt: 'Active session management',
  },
  settings: {
    title: 'Settings',
    subtitle: 'Configure your company profile and document defaults',
    saveSettings: 'Save Settings',
    saved: 'Settings saved!',
    companyLogo: 'Company Logo',
    preview: 'Preview',
    uploadImage: 'Upload Image',
    removeWhiteBg: 'Remove white background',
    remove: 'Remove',
    logoHeight: 'Logo Height (px)',
    previewNote: 'Preview shows on dark background like the PDF header.',
    whiteBgRemoved: 'White background removed — remember to save',
    logoProcessFailed: 'Could not process the logo image',
    companyInfo: 'Company Information',
    companyName: 'Company Name *',
    address: 'Address',
    cityState: 'City / State',
    phone: 'Phone',
    email: 'Email',
    website: 'Website',
    regNo: 'Registration No.',
    taxNo: 'Tax / SST No.',
    docAppearance: 'Document Appearance',
    docAppearanceIntro: 'Applies to every document you generate, in both the PDF and the Word file.',
    templateGallery: 'PDF Template',
    templateGalleryHint: 'Choose a visual style for your PDF documents. The Word download always uses the Classic layout.',
    tplClassic: 'Classic',
    tplMinimal: 'Minimal',
    tplBold: 'Bold',
    tplElegant: 'Elegant',
    tplGradient: 'Gradient',
    tplSlate: 'Slate',
    tplSoft: 'Soft',
    tplStripe: 'Stripe',
    tplFrame: 'Frame',
    tplMono: 'Mono',
    tplSidebar: 'Sidebar',
    tplLedger: 'Ledger',
    tplSlim: 'Slim',
    tplCurve: 'Curve',
    tplDiagonal: 'Diagonal',
    tplBanner: 'Banner',
    tplDuo: 'Duo',
    tplCards: 'Cards',
    tplPop: 'Pop',
    tplRoyal: 'Royal',
    tplMarker: 'Marker',
    tplSketch: 'Sketch',
    tplGhost: 'Outline',
    tplMidnight: 'Midnight',
    colorPresets: 'Colour Presets',
    colorPresetsHint: 'One-click colour pairs, applied on top of whichever template you pick — fine-tune with the pickers below.',
    presetNavy: 'Navy',
    presetSky: 'Sky',
    presetTeal: 'Teal',
    presetEmerald: 'Emerald',
    presetBurgundy: 'Burgundy',
    presetCrimson: 'Crimson',
    presetCopper: 'Copper',
    presetPlum: 'Plum',
    presetRose: 'Rose',
    presetGraphite: 'Graphite',
    headerColour: 'Header Colour',
    accentColour: 'Accent Colour',
    hexInvalid: 'Needs a 6-digit hex like #1A3C6E — the default will be used instead.',
    font: 'Font',
    bodySize: 'Body Text Size (px)',
    headerSizePct: 'Header Size (%)',
    headerTextSizes: 'Header Text Sizes (px) — each textbox in the header individually',
    hCompanyName: 'Company Name',
    hTagline: 'Website / Tagline',
    hContact: 'Contact Info',
    hDocTitle: 'Document Title',
    hMeta: 'No. / Date Lines',
    compactHeader: 'Compact header',
    compactHeaderHint: ' — move contact info under the website, beside the logo, to save vertical space',
    partySection: 'Prepared For / Issued By Section',
    partyLabels: 'Labels (px)',
    partyNames: 'Names (px)',
    partyDetails: 'Details (px)',
    headerGap: 'Space After Header (px)',
    headerGapHint: 'Space After Header controls the gap between the header band and this section (0 = touching).',
    resetTheme: 'Reset to default theme',
    currencyDefaults: 'Currency & Defaults',
    defaultCurrency: 'Default Currency',
    pdfMargin: 'PDF / Word Margin (cm)',
    defaultTerms: 'Default Terms & Conditions',
    termsPh: 'e.g. Payment is due within 30 days. A late fee of 1.5% per month applies to overdue accounts…',
    bankDetails: 'Bank / Payment Details',
    bankDetailsIntro: 'These details will appear on all invoices and receipts automatically.',
    bankName: 'Bank Name',
    accountNumber: 'Account Number',
    accountHolder: 'Account Holder Name',
    signatory: 'Authorized Signatory',
    signatoryName: 'Name',
    designation: 'Designation',
    signatureImage: 'Digital Signature Image',
    noSignature: 'No signature',
    removeSignature: 'Remove signature',
    pngRecommended: 'PNG with transparent background recommended.',
    saveAll: 'Save All Settings',
    errorSaving: 'Error saving',
  },
  subscription: {
    title: 'Subscription',
    subtitle: 'Manage your Invio plan and billing',
    currentPlan: 'Current Plan',
    freeTrial: 'Free Trial',
    none: 'None',
    trialEndsIn: 'Trial ends in',
    days: '{d} day(s)',
    renewsOn: 'Renews on',
    billingHistory: 'Billing History',
    subscribedSince: 'Subscribed since',
    totalPaid: 'Total paid',
    payDate: 'Date',
    payAmount: 'Amount',
    payPlan: 'Plan',
    payStatus: 'Status',
    payReceipt: 'Receipt',
    paySucceeded: 'Paid',
    payFailed: 'Failed',
    pastDueMsg: 'Payment failed. Please update your payment method to keep using Invio.',
    manageBilling: 'Manage Billing →',
    opening: 'Opening…',
    portalUnavailable: 'Portal unavailable',
    activated: 'Subscription activated! Refreshing…',
    checkoutCancelled: 'Checkout cancelled',
    readyToContinue: 'Ready to continue with Invio?',
    getInTouch: 'Get in touch',
    tailorPlan: "We'll tailor a plan to fit your business. Reach out and we'll get you set up.",
    talkToUs: 'Talk to Us',
    whatsapp: 'WhatsApp',
    choosePlan: 'Choose a plan',
    upgradeAnytime: 'Upgrade anytime',
    subscribeMonthly: 'Subscribe Monthly',
    subscribeYearly: 'Subscribe Yearly',
    redirecting: 'Redirecting…',
    checkoutFailed: 'Checkout failed. Please try again.',
    securePayment: 'Secure payment by Stripe. Cancel anytime.',
    needCustom: 'Need a custom plan?',
  },
  password: {
    length: 'At least 8 characters',
    lowercase: 'A lowercase letter',
    uppercase: 'An uppercase letter',
    digit: 'A number',
    symbol: 'A symbol (e.g. ! @ # $ %)',
    common: 'Not a commonly-used password',
    weak: 'Weak',
    fair: 'Fair',
    strong: 'Strong',
    excellent: 'Excellent',
    meetsAll: 'Meets all requirements',
  },
  server: {
    emailRegistered: 'Email already registered',
    invalidCredentials: 'Invalid email or password',
    accountDeactivated: 'Your account has been deactivated. Contact the administrator.',
    missingToken: 'Missing verification token',
    verifyInvalid: 'Invalid or already-used verification link',
    verifyExpired: 'Verification link has expired. Please request a new one.',
    emailRequired: 'Email is required',
    resetInvalid: 'This password reset link is invalid or has already been used.',
    resetExpired: 'This password reset link has expired. Please request a new one.',
    tooManyRequests: 'Too many attempts. Please wait a few minutes and try again.',
    currentPasswordRequired: 'Current password is required',
    currentPasswordWrong: 'Current password is incorrect',
    weakPassword: 'Password does not meet the security requirements.',
    aiPaidOnly: 'AI features require a paid subscription. Upgrade to use AI import.',
    missingFileData: 'Missing file data.',
    fileTooLarge: 'File exceeds the 25 MB limit.',
    itemNotFound: 'Item not found',
    clientNotFound: 'Client not found',
    docNotFound: 'Document not found',
    noStripeCustomer: 'No billing account linked yet. Subscribe first.',
    alreadySubscribed: 'You already have a subscription. Use Manage Billing to change it.',
    supportFieldsRequired: 'Subject and message are required',
    caseNotFound: 'Case not found',
    caseClosed: 'This case is closed. Please open a new case.',
    caseReopenExpired: 'This case can no longer be reopened. Please open a new case.',
    paymentNotPayable: 'Payments can only be recorded on invoices and bills.',
    paymentCancelledDoc: 'This document is cancelled.',
    paymentInvalidAmount: 'Enter a payment amount greater than zero.',
    paymentExceedsBalance: 'Payment is more than the balance due.',
    paymentInvalidDate: 'Invalid payment date.',
    paymentNotFound: 'Payment not found.',
    statusPaidByPayments: 'This document is fully paid. Remove a payment to change its status.',
    shareNotFound: 'This link is no longer available.',
    shareCannotRespond: 'This quotation can no longer be answered.',
    shareBadAction: 'Choose accept or decline.',
    shareNameRequired: 'Please enter your name.',
    sendNotConfigured: 'Email sending is not set up on this server.',
    sendVerifyFirst: 'Verify your own email address before sending documents.',
    sendNoRecipient: 'Enter the recipient email address.',
    sendTooManyRecipients: 'At most 5 addresses per field.',
    sendBadRecipient: 'One of the email addresses is not valid.',
    sendDailyLimit: 'Daily email limit reached. Try again tomorrow.',
    sendFailed: 'Could not send the email.',
    recurringBadFrequency: 'Unknown frequency.',
    recurringNoStart: 'Choose the date of the first invoice.',
    recurringEndBeforeStart: 'The end date is before the first invoice.',
    recurringNotInvoice: 'Only invoices can repeat.',
    recurringNotFound: 'Schedule not found.',
    einvoiceLocked: 'This document is a submitted LHDN e-Invoice and can no longer be changed. Cancel the e-Invoice (within 72 hours) or issue a credit note.',
    einvDisabled: 'e-Invoicing is not switched on.',
    einvNoCredentials: 'MyInvois client ID and secret are not set.',
    einvBadCredentials: 'MyInvois rejected the client ID / secret. Check them and the environment.',
    einvUnreachable: 'Could not reach MyInvois. Please try again.',
    einvNotReady: 'Some details are missing.',
    einvAlreadySubmitted: 'This document has already been submitted to LHDN.',
    einvSubmitFailed: 'MyInvois did not accept the submission.',
    einvRejected: 'MyInvois rejected the document.',
    einvNotValid: 'Only a validated e-Invoice can be cancelled.',
    einvCancelReason: 'Give a reason for the cancellation.',
    einvCancelWindow: 'The 72-hour cancellation window has passed — issue a credit note instead.',
    einvCancelFailed: 'MyInvois did not cancel the document.',
    einvApiError: 'MyInvois returned an error. Please try again.',
  },
  reset: {
    checking: 'Checking your reset link…',
    title: 'Choose a new password',
    intro: 'Enter a new password for your Invio account.',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    mismatch: 'The two passwords do not match.',
    submit: 'Reset Password',
    failedGeneric: 'Could not reset your password. Please try again.',
    success: 'Password updated',
    successBody: 'You can now sign in with your new password. Other devices have been signed out.',
    invalidTitle: 'Reset link not valid',
    invalidGeneric: 'This password reset link is invalid or has expired.',
    requestNew: 'Request a New Link',
  },
  verify: {
    verifying: 'Verifying your email…',
    justAMoment: 'Just a moment.',
    verified: 'Email verified',
    confirmed: 'is confirmed. You can now use Invio normally.',
    continue: 'Continue to Invio →',
    failed: 'Verification failed',
    failedGeneric: 'The verification link is invalid or has expired.',
    alreadySignedIn: 'Already signed in? You can request a new verification email from the banner at the top of any page.',
  },
  support: {
    title: 'Support',
    subtitle: 'Open a case and we will get back to you',
    newCase: 'New Case',
    empty: 'No support cases yet. Having a problem or a question? Open a case and we will help.',
    created: 'Case {n} opened — we will get back to you soon',
    createFailed: 'Could not open the case',
    subject: 'Subject *',
    subjectPh: 'Short summary of the issue',
    category: 'Category',
    priority: 'Priority',
    message: 'Describe the issue *',
    messagePh: 'What happened? What did you expect? Steps to reproduce help a lot…',
    attachments: 'Screenshots (optional, up to 3 images)',
    attachTooLarge: 'Image is too large (max 2 MB)',
    submit: 'Open Case',
    yourTurn: 'Reply needed',
    allCases: 'All cases',
    cat: { billing: 'Billing & subscription', bug: 'Bug / something broken', question: 'Question / how-to', feature: 'Feature request', other: 'Other' },
    status: { open: 'Open', in_progress: 'In progress', waiting_on_user: 'Awaiting your reply', resolved: 'Resolved', closed: 'Closed' },
    prio: { low: 'Low', normal: 'Normal', high: 'High' },
    resolvedTitle: 'This case was marked resolved',
    resolvedAsk: 'did this solve your problem?',
    confirmClose: 'Yes, close it',
    reopen: 'No, reopen',
    you: 'You',
    supportTeam: 'Invio Support',
    caseClosed: 'This case is closed. Need more help?',
    replyPh: 'Write a reply…',
    send: 'Send',
    sendFailed: 'Could not send',
    closedMsg: 'Case closed — thank you!',
    reopenedMsg: 'Case reopened — we will take another look',
  },
  notif: {
    title: 'Notifications',
    empty: 'No notifications yet',
    justNow: 'just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    daysAgo: '{n} d ago',
    trialExtended: 'Your trial was extended by {days} day(s). 🎉',
    trialReminder: 'Your trial ends in {days} day(s). Subscribe to keep access.',
    trialGrace: 'Your trial has ended — {days} grace day(s) left before your account is locked.',
    paymentFailed: 'Payment failed — update your payment method within {days} day(s) to keep access.',
    paymentRecovered: 'Payment recovered — your subscription is active again.',
    paymentReceipt: 'Payment received: {amount} — thanks! A receipt was emailed to you.',
    supportReply: 'Support replied to your case {n}.',
    supportResolved: 'Your support case {n} was resolved.',
    supportCase: 'New support case {n} from {from}.',
    supportUserReply: '{from} replied to support case {n}.',
    docViewed: '{client} opened {n}',
    quoteAccepted: '{client} accepted quotation {n}',
    quoteRejected: '{client} declined quotation {n}',
    recurringIssued: 'Recurring invoice {n} issued for {client}',
    recurringIssuedSent: 'Recurring invoice {n} issued and emailed to {client}',
    recurringIssuedError: 'Recurring invoice {n} issued, but not emailed: {error}',
    invoiceOverdue: 'Invoice {n} is now overdue',
    invoicesOverdue: '{count} invoices became overdue',
    einvoiceValid: 'LHDN validated e-Invoice {n}',
    einvoiceInvalid: 'LHDN rejected e-Invoice {n} — open it to see why',
  },
  impersonate: {
    banner: 'Admin support session',
    return: 'Return to admin',
  },
  payments: {
    title: 'Payments',
    record: 'Record payment',
    none: 'No payments recorded yet.',
    paid: 'Amount paid',
    balance: 'Balance due',
    balanceShort: 'Balance {amount}',
    amount: 'Amount',
    date: 'Payment date',
    method: 'Method',
    reference: 'Reference no.',
    referencePh: 'e.g. bank transfer reference',
    note: 'Note',
    notePh: 'e.g. 30% deposit',
    payFull: 'Full balance',
    save: 'Save payment',
    recorded: 'Payment recorded',
    removed: 'Payment removed',
    confirmRemove: 'Remove this payment?',
    failed: 'Could not save the payment',
    fullyPaid: 'Paid in full',
    m_bank_transfer: 'Bank transfer',
    m_cash: 'Cash',
    m_card: 'Card',
    m_cheque: 'Cheque',
    m_ewallet: 'E-wallet',
    m_online: 'Online payment',
    m_other: 'Other',
  },
  statement: {
    title: 'Statement of Account',
    button: 'Statement',
    back: 'Clients',
    from: 'From',
    to: 'To',
    currency: 'Currency',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    thisYear: 'This year',
    downloadPdf: 'Download PDF',
    opening: 'Opening balance',
    closing: 'Closing balance',
    invoiced: 'Invoiced',
    paid: 'Paid',
    credited: 'Credited',
    paidCredit: 'Paid / Credit',
    balanceDue: 'Balance due',
    balance: 'Balance',
    date: 'Date',
    details: 'Details',
    k_invoice: 'Invoice',
    k_payment: 'Payment received',
    k_credit_note: 'Credit note',
    due: 'Due {date}',
    empty: 'No transactions in this period.',
    aging: 'Outstanding by age',
    current: 'Current',
    days: '{range} days',
    loadFailed: 'Could not load the statement',
  },
  share: {
    send: 'Send',
    title: 'Send {n}',
    cardTitle: 'Sharing',
    linkTitle: 'Public link',
    linkHelp: 'Anyone with this link can view the document and download the PDF. No login needed.',
    createLink: 'Create link',
    copy: 'Copy',
    copied: 'Link copied',
    open: 'Open',
    disable: 'Turn off link',
    disableConfirm: 'Turn off this link? Anyone who already has it will no longer be able to open it.',
    disabled: 'Link turned off',
    whatsapp: 'Share on WhatsApp',
    whatsappText: 'Hi {name}, here is {type} {n} from {company}:\n{url}',
    emailTitle: 'Email to client',
    to: 'To',
    cc: 'Cc (optional)',
    ccPh: 'accounts@client.com, you@company.com',
    subject: 'Subject',
    message: 'Message',
    defaultSubject: '{type} {n} from {company}',
    defaultMessage: 'Hi {name},\n\nPlease find {type} {n} attached.\n\nThank you,\n{sender}',
    attachPdf: 'Attach the PDF',
    includeLink: 'Include a "view online" button',
    replyNote: 'Sent under your company name. Replies go to {email}.',
    sendEmail: 'Send email',
    sending: 'Sending…',
    sent: 'Email sent to {to}',
    sendFailed: 'Could not send the email',
    linkFailed: 'Could not create the link',
    linkOn: 'Public link is on',
    linkOff: 'Not shared yet',
    views: 'Viewed {n} time(s)',
    notViewed: 'Not viewed yet',
    lastViewed: 'Last viewed {date}',
    lastEmailed: 'Emailed to {to} on {date}',
    responded_accepted: 'Accepted by {name} on {date}',
    responded_rejected: 'Declined by {name} on {date}',
    reminderSubject: 'Reminder: {type} {n} from {company}',
    reminderMessage: 'Hi {name},\n\nThis is a friendly reminder that {type} {n} is still awaiting payment. It may simply have been overlooked.\n\nIf you have already paid, please ignore this message — and thank you.\n\nRegards,\n{sender}',
  },
  publicDoc: {
    loading: 'Loading document…',
    notFoundTitle: 'This link is no longer available',
    notFoundBody: 'The sender may have turned it off. Please ask them for a new link.',
    from: 'From',
    to: 'To',
    issued: 'Issued',
    due: 'Due',
    validUntil: 'Valid until',
    downloadPdf: 'Download PDF',
    preparing: 'Preparing…',
    pdfFailed: 'Could not prepare the PDF. Please try again.',
    amountDue: 'Amount due',
    paidInFull: 'Paid in full — thank you!',
    howToPay: 'How to pay',
    acceptTitle: 'Respond to this quotation',
    yourName: 'Your full name',
    accept: 'Accept quotation',
    decline: 'Decline',
    declineConfirm: 'Decline this quotation?',
    acceptNote: 'By accepting, you confirm the items, prices and terms shown above.',
    accepted: 'Accepted by {name} on {date}',
    rejected: 'Declined by {name} on {date}',
    respondFailed: 'Could not save your response. Please try again.',
    poweredBy: 'Sent with Invio — create your own invoices free for 30 days',
    regNo: 'Reg. no.',
    taxNo: 'Tax no.',
  },
  recurring: {
    title: 'Recurring Invoices',
    subtitle: 'Invoices that issue themselves on a schedule',
    empty: 'No recurring invoices yet. Open any invoice and choose “Make recurring”.',
    goInvoices: 'Go to invoices',
    make: 'Make recurring',
    modalTitle: 'Repeat {n}',
    modalIntro: 'Invio will issue a new invoice with the same items on this schedule. This invoice itself is not changed.',
    frequency: 'Repeat',
    every: 'Every',
    f_weekly: 'week(s)',
    f_monthly: 'month(s)',
    f_quarterly: 'quarter(s)',
    f_yearly: 'year(s)',
    firstInvoice: 'First invoice on',
    endDate: 'End date (optional)',
    dueDays: 'Payment due after (days)',
    autoSend: 'Email each invoice to the client automatically',
    autoSendHelp: 'Off: invoices are created as drafts for you to review and send.',
    noClientEmail: 'This client has no email address — add one to use auto-send.',
    create: 'Start schedule',
    created: 'Recurring invoice set up. Next one: {date}',
    saved: 'Schedule updated',
    failed: 'Could not save the schedule',
    thClient: 'Client / invoice',
    thAmount: 'Amount',
    thSchedule: 'Schedule',
    thNext: 'Next invoice',
    thStatus: 'Status',
    summary: 'Every {n} {unit}',
    issued: '{n} issued',
    last: 'Last: {n}',
    until: 'until {date}',
    autoSendOn: 'Auto-send',
    asDraft: 'Creates drafts',
    s_active: 'Active',
    s_paused: 'Paused',
    s_ended: 'Ended',
    pause: 'Pause',
    resume: 'Resume',
    runNow: 'Issue now',
    runConfirm: 'Issue the next invoice now?',
    ran: '{n} issued',
    deleteConfirm: 'Delete this schedule? Invoices already issued are kept.',
    deleted: 'Schedule deleted',
    lastError: 'Last run: {msg}',
    fromSchedule: 'Issued by a recurring schedule',
    basedOn: 'Based on {n}',
  },
  reminders: {
    title: 'Payment reminders',
    intro: 'Invio can email your clients automatically when an invoice is about to fall due or is overdue. Emails go out under your company name with a link to the invoice; replies come to you. Invoices are always marked overdue automatically, whether or not reminders are on.',
    enable: 'Send payment reminders to clients automatically',
    before: 'Days before the due date (0 = off)',
    after: 'Days after the due date',
    afterHelp: 'Comma separated, e.g. 1, 7, 14',
    needsEmail: 'Only invoices whose client has an email address get reminders. You can exclude a single invoice from its page.',
    docToggle: 'No automatic reminders for this invoice',
    docSent: 'Reminders sent: {n}',
    updated: 'Reminder preference saved',
  },
  onboarding: {
    title: 'Get started with Invio',
    subtitle: 'Four quick steps to your first invoice with your own logo on it.',
    progress: '{done} of {total} done',
    dismiss: 'Hide this',
    s_company: 'Add your company details',
    d_company: 'Your name and logo appear on every document.',
    s_client: 'Add your first client',
    d_client: 'Save their details once, reuse them on every quote and invoice.',
    s_document: 'Create your first invoice or quotation',
    d_document: 'Pick a client, add items, done. Export to PDF or Word any time.',
    s_sent: 'Send it to your client',
    d_sent: 'By email with the PDF attached, on WhatsApp, or as a link — and see when they open it.',
    companyName: 'Company name',
    phone: 'Phone',
    logo: 'Logo (optional)',
    saveCompany: 'Save',
    moreSettings: 'More settings',
    companySaved: 'Company details saved',
    addClient: 'Add a client',
    newInvoice: 'New invoice',
    newQuotation: 'New quotation',
    openDocs: 'Open my documents',
    sampleTitle: 'Just want to see how it looks?',
    sampleBody: 'Create a sample invoice in one click and open it as a PDF with your branding. It stays a draft — delete it whenever you like.',
    sampleCreate: 'Create a sample invoice',
    sampleOpen: 'Open the sample invoice',
    sampleFailed: 'Could not create the sample',
    sampleBanner: 'This is a sample invoice. Try the PDF and Send buttons, then delete it — it is a draft and does not affect your numbers.',
  },
  einv: {
    title: 'LHDN e-Invoice (MyInvois)',
    subtitle: 'Submit invoices and credit notes to LHDN for validation, straight from Invio',
    back: 'Settings',
    settingsIntro: 'Malaysia is making e-Invoicing mandatory in phases. Connect your MyInvois account and Invio will submit your invoices to LHDN and put the validation QR code on the PDF.',
    open: 'Set up e-Invoice',
    statusOn: 'On — {env}',
    statusOff: 'Not set up',
    stepsTitle: 'How to connect',
    step1: 'Sign in to the MyInvois portal (start with the sandbox: preprod.myinvois.hasil.gov.my).',
    step2: 'Open your taxpayer profile → Representatives → Register ERP. Name it “Invio”.',
    step3: 'Copy the Client ID and Client Secret it shows you (the secret is shown only once) and paste them below.',
    step4: 'Test the connection, submit a test invoice in the sandbox, then switch to Production with your production keys.',
    enable: 'Use LHDN e-Invoicing',
    connection: 'MyInvois connection',
    environment: 'Environment',
    sandbox: 'Sandbox (testing)',
    production: 'Production (real e-Invoices)',
    clientId: 'Client ID',
    clientSecret: 'Client Secret',
    secretSaved: 'Saved — leave blank to keep it',
    secretNote: 'Stored encrypted. It is never shown again or sent back to your browser.',
    test: 'Test connection',
    testing: 'Testing…',
    testOk: 'Connected to MyInvois ({env}).',
    testTinValid: 'Your TIN and registration number match LHDN\'s records.',
    testTinInvalid: 'Connected, but LHDN does not recognise this TIN + registration number combination.',
    saveFirst: 'Save your settings first, then test.',
    supplier: 'Your tax details',
    supplierNote: 'Company name, address, city and email come from your main Settings.',
    tin: 'TIN (Tax Identification Number)',
    idType: 'ID type',
    id_BRN: 'Business registration no. (BRN)',
    id_NRIC: 'MyKad / NRIC',
    id_PASSPORT: 'Passport',
    id_ARMY: 'Army ID',
    idValue: 'ID / registration number',
    sstNo: 'SST registration no. (if registered)',
    ttxNo: 'Tourism tax no. (if any)',
    msic: 'MSIC code (5 digits)',
    msicHelp: 'Find yours in the MyInvois portal profile or LHDN\'s MSIC list.',
    activity: 'Business activity description',
    postcode: 'Postcode',
    state: 'State',
    chooseState: 'Choose a state…',
    phone: 'Contact number',
    defaults: 'Defaults for every e-Invoice',
    classification: 'Classification of what you sell',
    classificationHelp: '“022 Others” suits most businesses. You can change it per invoice when submitting.',
    taxType: 'The tax you charge (when an invoice has tax)',
    taxNone: 'I do not charge tax',
    tax_01: 'Sales Tax',
    tax_02: 'Service Tax',
    save: 'Save e-Invoice settings',
    saved: 'e-Invoice settings saved',
    versionNote: 'Invio submits document version 1.0, which LHDN accepts without a digital certificate. Version 1.1 (digitally signed) will follow when LHDN retires 1.0.',
    clientSection: 'e-Invoice details (LHDN)',
    clientSectionHelp: 'Only needed if you submit e-Invoices for this client.',
    buyerTin: 'Client\'s TIN',
    generalPublic: 'No TIN — Malaysian individual',
    generalForeign: 'No TIN — foreign buyer',
    country: 'Country (3-letter code)',
    checkTin: 'Check with LHDN',
    tinValid: 'LHDN recognises this TIN and ID.',
    tinInvalid: 'LHDN does not recognise this TIN + ID combination.',
    card: 'LHDN e-Invoice',
    st_none: 'Not submitted',
    st_submitted: 'Submitted — waiting for LHDN',
    st_valid: 'Validated by LHDN',
    st_invalid: 'Rejected by LHDN',
    st_cancelled: 'e-Invoice cancelled',
    submit: 'Submit to LHDN',
    resubmit: 'Fix and submit again',
    submitting: 'Submitting…',
    refresh: 'Check status',
    viewOnPortal: 'View on MyInvois',
    uuid: 'UUID',
    validatedOn: 'Validated {date}',
    sandboxBadge: 'Sandbox',
    locked: 'This document is locked: what LHDN validated must stay what your client holds. To change it, cancel the e-Invoice (within 72 hours) or issue a credit note.',
    modalTitle: 'Submit {n} to LHDN',
    modalIntro: 'LHDN validates the e-Invoice within seconds. Once validated the document is locked and the PDF carries the LHDN QR code.',
    sandboxWarning: 'Sandbox mode: this is a test submission and has no legal effect.',
    productionWarning: 'Production: this is a real e-Invoice reported to LHDN.',
    fixFirst: 'Fix these first:',
    fixInSettings: 'e-Invoice settings',
    fixInClient: 'Edit the client',
    exchangeRate: 'Exchange rate: 1 {cur} = ? MYR',
    notEnabled: 'e-Invoicing is not set up yet.',
    done_valid: 'Validated by LHDN ✓',
    done_submitted: 'Submitted. LHDN is still validating — check the status in a moment.',
    done_invalid: 'LHDN rejected the e-Invoice — see the reasons on the document.',
    failed: 'Could not submit to LHDN',
    cancel: 'Cancel e-Invoice',
    cancelTitle: 'Cancel the LHDN e-Invoice',
    cancelIntro: 'LHDN allows cancellation for 72 hours after validation. After that, issue a credit note instead. Your client is notified by LHDN.',
    cancelReason: 'Reason',
    cancelReasonPh: 'e.g. Wrong amount',
    cancelled: 'e-Invoice cancelled',
    publicBadge: 'Validated LHDN e-Invoice',
    publicVerify: 'Verify on MyInvois',
  },
  einvP: {
    einvType: 'Only invoices and credit notes can be submitted as e-Invoices.',
    einvCancelledDoc: 'This document is cancelled.',
    einvNoItems: 'The document has no line items.',
    einvItemDescription: 'Every line item needs a description.',
    einvSupplierTin: 'Your TIN is missing or not valid.',
    einvSupplierId: 'Your business registration / ID number is missing.',
    einvMsic: 'Your 5-digit MSIC code is missing.',
    einvActivity: 'Your business activity description is missing.',
    einvSupplierName: 'Your company name is missing (Settings).',
    einvSupplierAddress: 'Your company address is missing (Settings).',
    einvSupplierCity: 'Your company city is missing (Settings).',
    einvSupplierState: 'Choose your state.',
    einvSupplierPhone: 'Your contact number is missing.',
    einvNoClient: 'Link this document to a client.',
    einvBuyerTin: 'The client\'s TIN is missing (use the general TIN for buyers without one).',
    einvBuyerId: 'The client\'s registration / ID number is missing.',
    einvBuyerAddress: 'The client\'s address is missing.',
    einvBuyerCity: 'The client\'s city is missing.',
    einvBuyerState: 'Choose the client\'s state.',
    einvBuyerCountry: 'The client\'s country must be a 3-letter code (e.g. MYS).',
    einvBuyerPhone: 'The client\'s phone number is missing.',
    einvExchangeRate: 'Enter the exchange rate to MYR.',
    einvTaxType: 'Choose whether the tax you charge is Sales Tax or Service Tax.',
    einvSstNo: 'Your SST registration number is required when you charge tax.',
    einvOriginal: 'A credit note must be created from an invoice that is already a validated e-Invoice.',
  },
  common: {
    save: 'Save',
    saving: 'Saving…',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    loading: 'Loading…',
    welcome: 'Good day',
    overview: "Here's your business overview",
    language: 'Language',
  },
};
export default en;
